import { render, staticRenderFns } from "./LayoutCard.pug?vue&type=template&id=6ca9118d&scoped=true&lang=pug&"
import script from "./LayoutCard.vue?vue&type=script&lang=js&"
export * from "./LayoutCard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCard.scss?vue&type=style&index=0&id=6ca9118d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9118d",
  null
  
)

export default component.exports